import Toastify from 'toastify-js'
import "toastify-js/src/toastify.css"


// Optional: attach to window for global access
window.Toastify = Toastify

// Or define a helper wrapper
window.toastifyNotify = function(text, options = {}) {

  const defaults = {
    text: text,
    duration: 3000,
    gravity: "bottom",
    position: "right",
    close: true,
    stopOnFocus: true,
    backgroundColor: "#333",
    className: 'toast-messages-custom',
  }

  Toastify({
    ...defaults,
    ...options
  }).showToast()
}
